import { BaseCard } from '../BaseCard/BaseCard'
import { Skeleton } from '../shadcn'

export const BlockSkeleton = () => {
  return (
    <BaseCard className="!py-8 !px-6">
      <Skeleton className="w-[120px] h-7 mb-5" />
      <Skeleton className="w-full h-4 mb-2 rounded-sm" />
      <Skeleton className="w-full h-12" />
    </BaseCard>
  )
}
